module.exports = __webpack_public_path__ + "static/sport/bg4.c0b953d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/bg4.png
// module id = Yfg1
// module chunks = 0